"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = undefined;

var _EnvConfig = require("./EnvConfig");

var _EnvConfig2 = _interopRequireDefault(_EnvConfig);

var _firebase = require("firebase");

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// don't init firebase if we're on the server, it's done elsewhere. this is for clients.
var config = exports.config = process.env.GCLOUD_PROJECT ? null : _EnvConfig2.default.firebase;
if (config) {
  _firebase2.default.initializeApp(config);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWR1eC9GaXJlYmFzZS5qcyJdLCJuYW1lcyI6WyJjb25maWciLCJwcm9jZXNzIiwiZW52IiwiR0NMT1VEX1BST0pFQ1QiLCJmaXJlYmFzZSIsImluaXRpYWxpemVBcHAiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQTtBQUNPLElBQU1BLDBCQUFTQyxRQUFRQyxHQUFSLENBQVlDLGNBQVosR0FBNkIsSUFBN0IsR0FBb0Msb0JBQVVDLFFBQTdEO0FBQ1AsSUFBSUosTUFBSixFQUFZO0FBQ1YscUJBQVNLLGFBQVQsQ0FBdUJMLE1BQXZCO0FBQ0QiLCJmaWxlIjoiRmlyZWJhc2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IGVudkNvbmZpZyBmcm9tIFwiLi9FbnZDb25maWdcIlxuaW1wb3J0IGZpcmViYXNlIGZyb20gXCJmaXJlYmFzZVwiXG5cbi8vIGRvbid0IGluaXQgZmlyZWJhc2UgaWYgd2UncmUgb24gdGhlIHNlcnZlciwgaXQncyBkb25lIGVsc2V3aGVyZS4gdGhpcyBpcyBmb3IgY2xpZW50cy5cbmV4cG9ydCBjb25zdCBjb25maWcgPSBwcm9jZXNzLmVudi5HQ0xPVURfUFJPSkVDVCA/IG51bGwgOiBlbnZDb25maWcuZmlyZWJhc2VcbmlmIChjb25maWcpIHtcbiAgZmlyZWJhc2UuaW5pdGlhbGl6ZUFwcChjb25maWcpXG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../core/lib/redux/Firebase.js
// module id = 827
// module chunks = 0